import {
  Box,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import TableSkeleton from "components/skeletons/TableSkeleton";
import TablePagination from "components/tablePagination";
import PrintReceipt from "components/common/payment/PrintReceipt";
import moment from "moment";
import { Delete, Edit } from "@mui/icons-material";
import { useState } from "react";
import { deletePayment } from "features/payments/api/payments";
import Alert from "components/alert";
import { toast } from "react-toastify";

const PaymentTable = ({
  loading,
  allPayment,
  setAllPayment,
  pagination,
  setPagination,
  setReload,
  setAddPayment,
  setCurrPayment,
  isEdit,
  isDelete,
  permissions,
}) => {
  const rows = allPayment;
  const columns = [
    { id: "invoice_number", label: "Invoice Number" },
    { id: "created_at", label: "Created Date" },
    { id: "created_by_name", label: "Created By" },
    { id: "customer_name", label: "Customer Name" },
    {
      id: "payment_method_name",
      label: "Pay Method",
      style: { width: "120px" },
    },
    { id: "payment_date", label: "Payment Date", style: { width: "130px" } },
    { id: "amount", label: "Amount", align: "right" },
    {
      id: "action",
      label: "Action",
      align: "center",
      style: { width: "100px" },
    },
  ];

  const [openAlert, setOpenAlert] = useState(false);

  const handleDelete = async (id) => {
    setOpenAlert(id);
  };

  const handleDeleteConfirm = async () => {
    const result = deletePayment({ id: openAlert });
    if (result.success) {
      toast.success(result.message);
      setAllPayment(allPayment.filter((task) => task.id !== openAlert));
    } else {
      toast.error(result.message);
    }
    setOpenAlert(false);
  };

  const handleEditBtn = (value) => {
    setCurrPayment(value);
    setAddPayment(true);
  };

  return (
    <>
      {openAlert && (
        <Alert
          open={openAlert}
          handleClose={setOpenAlert}
          title="Delete Payment"
          desc={
            <Box>
              Are you sure you want to delete? This will delete this Payment
              permanently. <strong>You can't undo this action</strong>
            </Box>
          }
          buttons={
            <>
              <Button onClick={() => setOpenAlert(false)}>No, keep it</Button>
              <Button variant="solid" onClick={handleDeleteConfirm}>
                Yes, delete it
              </Button>
            </>
          }
        />
      )}

      {!loading ? (
        <TableContainer
          sx={{ height: "calc(100vh - 245px)", overflowX: "auto" }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows?.map((row) => {
                return (
                  <TableRow hover role="checkbox" key={row.id}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === "number" ? (
                            column.format(value)
                          ) : column.id === "Payment_date" ? (
                            moment(value).format("ll")
                          ) : column.id === "created_at" ? (
                            moment(value).format("ll")
                          ) : column.id === "tax" ? (
                            <Typography color="#2fb42f" variant="body2">
                              {"+ " + row.symbol + value}
                            </Typography>
                          ) : column.id === "discount" ? (
                            <Typography color="#ff3535" variant="body2">
                              {"- " + row.symbol + value}
                            </Typography>
                          ) : column.id === "total" ? (
                            <Typography color="#7171ff" variant="body2">
                              {row.symbol}
                              {value + row.tax - row.discount}
                            </Typography>
                          ) : column.id === "subtotal" ? (
                            <Typography variant="body2">
                              {row.symbol + value}
                            </Typography>
                          ) : column.id === "action" ? (
                            // Add action buttons or components here
                            <>
                              <Box
                                sx={{
                                  display: "flex",
                                  gap: "10px",
                                  justifyContent: "center",
                                }}
                              >
                                <PrintReceipt
                                  paymentData={row}
                                  disabled={!permissions.show}
                                />
                                {isEdit && (
                                  <IconButton
                                    onClick={() => handleEditBtn(row)}
                                    disabled={!permissions.update}
                                  >
                                    <Edit />
                                  </IconButton>
                                )}
                                {isDelete && (
                                  <IconButton
                                    onClick={() => handleDelete(row.id)}
                                    disabled={!permissions.delete}
                                  >
                                    <Delete />
                                  </IconButton>
                                )}
                              </Box>
                            </>
                          ) : (
                            value
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <TableSkeleton columns={columns} tableHeight="calc(100vh - 245px)" />
      )}
      <TablePagination
        span={columns?.length}
        setReload={setReload}
        pagination={pagination}
        setPagination={setPagination}
      />
    </>
  );
};

export default PaymentTable;
